<template lang="pug">
    v-layout(row)
        .buttons-area(
            
        )
            v-btn(
                v-for="(item, idx) in items" 
                :key="idx"
                :color="item.color"
                dark
                block 
                :outline="item.value !== selectedValue"
                @click="handleSelection(item.value)"
            )
                span {{item.label}}
            
</template>

<script>
export default {
    name: 'transaction-tc-select',
    props: {
        /**
         * @description
         * Gets an array of objects to render as button controls.
         * @example
         *  {
         *      label: 'boleta',
         *      value: 'ticket',
         *      color: 'light-green darken-3' 
         *  } 
         */
        items: {
            type: Array,
            default: () => [
                {
                    value: 'ticket',
                    label: 'Boleta',
                    color: 'light-green darken-3'
                }
            ]
        },
        /**
         * @description
         * Value to be controlled and returned by the selection component.
         */
        value: {
            default: () => 'ticket'
        },
    },
    data: function(){
        return {
            /**
             * @description
             * stores the selected transaction type
             */
            selectedValue: 'ticket'
        }
    },
    computed: {},
    methods: {
        /**
         * @description
         */
        handleSelection: function(newValue){
            this.selectedValue = newValue
            this.$emit('input', newValue) 
            return
        },
    },
    watch: {},
    components: {},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
    .buttons-area{
        display: flex;
        flex-grow: 1;
        flex-basis: 0;
        flex-wrap: wrap;
    }
</style>